import React from "react";

const MyShotClassIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24.475"
      height="24.475"
      viewBox="0 0 24.475 24.475"
    >
      <g id="db41" transform="translate(-182.27 -182.27)">
        <path
          id="Path_1280"
          data-name="Path 1280"
          d="M182.27,295.952v1.53h24.475V279.125H182.27Zm6.525-14.532h0a2.408,2.408,0,1,1-1.7.705,2.409,2.409,0,0,1,1.7-.705Zm-2.929,6.119h5.851a1.287,1.287,0,0,1,.62.161c.038.023.069.038.107.061h.008c.054.038.107.069.161.115l3.526,3.006,3.71-3.174a1.3,1.3,0,1,1,1.69,1.973l-4.551,3.9a1.3,1.3,0,0,1-1.69,0l-2.279-1.943v4.314h-8.452v-7.113a1.3,1.3,0,0,1,1.3-1.3Z"
          transform="translate(0 -90.737)"
        />
        <path
          id="Path_1281"
          data-name="Path 1281"
          d="M182.27,182.27v4.589h24.475V182.27Zm2.294,3.059a.765.765,0,1,1,.765-.765.765.765,0,0,1-.765.765Zm3.059,0a.765.765,0,1,1,.765-.765.765.765,0,0,1-.765.765Zm3.059,0a.765.765,0,1,1,.765-.765.765.765,0,0,1-.765.765Zm14.532,0H196.8V183.8h8.414Z"
          transform="translate(0)"
        />
      </g>
    </svg>
  );
};

export default MyShotClassIcon;
